/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconBill extends React.Component {
  render() {
    const iconClasses = classNames("icon bill", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M23,3l-2-1l-2,1l-2-1l-2,1l-2-1l-2,1L9,2L7,3L5,2v24c0,1.105,0.895,2,2,2h16c1.105,0,2-0.895,2-2V2L23,3z M16,23h-6 c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h6c0.552,0,1,0.448,1,1C17,22.552,16.552,23,16,23z M9,18c0-0.552,0.448-1,1-1h4 c0.552,0,1,0.448,1,1c0,0.552-0.448,1-1,1h-4C9.448,19,9,18.552,9,18z M16,15h-6c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h6 c0.552,0,1,0.448,1,1C17,14.552,16.552,15,16,15z M20,23c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1 C21,22.552,20.552,23,20,23z M20,19c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C21,18.552,20.552,19,20,19z M20,15 c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C21,14.552,20.552,15,20,15z M20,9H10C9.448,9,9,8.552,9,8 c0-0.552,0.448-1,1-1h10c0.552,0,1,0.448,1,1C21,8.552,20.552,9,20,9z" />
      </svg>
    );
  }
}

IconBill.defaultProps = {
  className: null
};

IconBill.propTypes = {
  className: PropTypes.string
};

export default IconBill;
